'use strict';

exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
};

exports.default = isClassComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/recompose/isClassComponent.js
 ** module id = 342
 ** module chunks = 0
 **/